module.exports = __webpack_public_path__ + "img/中央空调.353b399c.webp";